// src/utils/audioErrors.ts
import { message } from 'antd';
import i18n from '../i18n';

const MESSAGE_DURATION = 2; // s
const MIN_INTERVAL = 60 * 1000; // ms – przy dłuższej awarii komunikat najwyżej raz na minutę
const AUDIO_START_TIMEOUT = 5000; // ms – tyle czekamy, aż lektor zacznie mówić

// Przerwanie dźwięku przez grę (AbortError) i blokada dźwięku przez przeglądarkę
// (NotAllowedError) to nie błąd połączenia — wtedy bez komunikatu.
const NOT_CONNECTION_ERRORS = ['AbortError', 'NotAllowedError'];

let lastShownAt = 0;

export const notifyAudioError = (error?: unknown): void => {
  const errorName = (error as { name?: string } | undefined)?.name;
  if (errorName && NOT_CONNECTION_ERRORS.includes(errorName)) return;

  const now = Date.now();
  if (now - lastShownAt < MIN_INTERVAL) return;
  lastShownAt = now;

  message.warning({ content: i18n.t('games:audioError'), key: 'audio-error', duration: MESSAGE_DURATION });
};

// Lektor, który nie zacznie mówić w ciągu AUDIO_START_TIMEOUT (np. serwer nie odpowiada),
// traktujemy jak błąd: zatrzymujemy dźwięk, żeby nie odezwał się później, i wołamy onTimeout.
// Gdy dźwięk ruszy, zgłosi błąd albo zostanie zatrzymany, playPromise się rozstrzyga i czekanie się kończy.
export const watchAudioStart = (
  audio: HTMLAudioElement,
  playPromise: Promise<void>,
  onTimeout: () => void,
): void => {
  const timer = setTimeout(() => {
    audio.pause();
    onTimeout();
  }, AUDIO_START_TIMEOUT);
  const clear = () => clearTimeout(timer);

  playPromise.then(clear, clear);
};
